import { render, staticRenderFns } from "./other-charges-actions-menu.vue?vue&type=template&id=3c1ae418"
import script from "./other-charges-actions-menu.vue?vue&type=script&lang=js"
export * from "./other-charges-actions-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports